import { OfflinePurchasePosition, OrderPosition } from '@@types'

import { BRAND_CONFIG } from '@@brand'

import ImageWithBg from '@shared/ui/image-with-bg'

import styles from './styles.module.scss'

interface OrderItemPreviewListProps {
  items: Array<OrderPosition | OfflinePurchasePosition> | null | undefined // Обобщаем типы для поддержки как онлайн, так и оффлайн заказов
}

export default function OrderItemPreviewList ({
  items,
}: OrderItemPreviewListProps) {
  const previewItems = items?.slice(0, 5)
  const hiddenCount = items?.length && items?.length - 5

  return (
    <div className={styles.previews}>
      {previewItems?.map((el, index) => (
        <div key={el?.id} className={styles.previews__item}>
          <ImageWithBg
            src={
              (el?.product?.preview?.url as string) ?? BRAND_CONFIG.images.productPlaceholder
            }
            className={styles.previews__img}
          />
          {index === 4 && hiddenCount && hiddenCount > 0 ? (
            <div className={styles.previews__more}>+ {hiddenCount}</div>
          ) : null}
        </div>
      ))}
    </div>
  )
}